<template>
    <div class="team-panel">
        <div class="team-info-items">
            <div class="team-info-item">
                <p class="team-info-item-value">
                    正式版
                </p>
                <hr>
                <div class="team-info-item-text">
                    <span class="icon-icomoon-Version"></span>
                    产品版本
                </div>
            </div>
            <div class="team-info-item">
                <p class="team-info-item-value">
                    2
                </p>
                <hr>
                <div class="team-info-item-text">
                    <span class="icon-icomoon-map"></span>
                    地图数量
                </div>
            </div>
            <div class="team-info-item">
                <p class="team-info-item-value">702</p>
                <hr>
                <div class="team-info-item-text">
                    <span class="icon-icomoon-record"></span>
                    记录数
                </div>
            </div>
            <div class="team-info-item">
                <p class="team-info-item-value">
                    1位/16位
                </p>
                <hr>
                <div class="team-info-item-text">
                    <span class="icon-icomoon-team"></span>
                    现有成员/额定成员
                </div>
            </div>
            <div class="team-info-item">
                <p class="team-info-item-value">
                    2025-04-29
                </p>
                <hr>
                <div class="team-info-item-text">
                    <span class="icon-icomoon-expiration"></span>
                    到期时间
                    <a href="#" class="team-info-item-btn">
                        延期申请
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'TeamPanel',
    components: {

    },
    data() {
        return {

        }
    },
    mounted() {


    },
    methods: {


    }
}

</script>

<style scoped>
.team-panel {
    width: calc(100% - 200px);
    height: 100%;
    padding: 10px;
    background-color: #f8fbfe;
    float: left;
}

.team-info-items {
    width: 100%;
    float: left;
    clear: both;
    min-width: 1040px;
    height: 100px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-around;
}

.team-info-item {
    width: 24%;
    margin: 0px 5px;
    flex-grow: 1;
    height: 100%;
    border: 1px solid #e6e9ed;
    background-color: #fff;
    position: relative;
}

.team-info-item-value {
    text-align: center;
    line-height: 60px;
    color: #576d8b;
    font-size: 24px;
}

.team-info-item-btn {
    position: absolute;
    background-color: #0095ff;
    border: 1px solid #0095ff;
    color: #fff;
    margin-top: 4px;
    padding: 1px 5px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
    right: 10px;
    bottom: 10px;

}

.team-info-item hr {
    margin-top: 4px;
    margin-bottom: 4px;
    border: 0;
    border-top: 1px solid #eeeeee;
}

.team-info-item-text {
    padding: 0 16px;
    font-size: 14px;
    color: #576d8b;
    line-height: 24px;
    text-align: left;
}

@media screen and (min-width: 1440px) {
    .team-info-items {
        height: 160px;
    }

    .team-info-item-value {
        font-size: 26px;
        height: 110px;
        line-height: 110px;
    }
    .team-info-item-text {
        line-height: 36px;
        font-size: 16px;
        height: 40px;
    }
}

@media screen and (min-width: 1920px) {
    .team-info-items {
        height: 160px;
    }

    .team-info-item-value {
        font-size: 26px;
        height: 110px;
        line-height: 110px;
    }

    .team-info-item-text {
        height: 40px;
        line-height: 36px;
        font-size: 18px;
    }
}
</style>